export default __webpack_public_path__ + "static/media/project_shot_east_douglas_2.5f567c73.jpg";